export default __webpack_public_path__ + "static/media/ninos-Personaje-Banner-Principal-1.9263ccbe.png";